import { useSelector } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import moment from "moment-jalaali";

export default function leaderBoardList(number: number) {
  const { newsData, articlesData, projectsData, usersData, departmentsData } =
    useSelector(selectGlobalState);

  const oneWeekAgo = moment().utc().subtract(number, "days");

  const totalActivities =
    (newsData?.filter((item: any) =>
      moment(item.created_at).utc().isSameOrAfter(oneWeekAgo)
    ).length || 0) +
    (articlesData?.filter((item: any) =>
      moment(item.created_at).utc().isSameOrAfter(oneWeekAgo)
    ).length || 0) +
    (projectsData?.filter((item: any) =>
      moment(item.created_at).utc().isSameOrAfter(oneWeekAgo)
    ).length || 0);

  const userData = usersData
    .filter((item: any) => item.is_active && item.main_department)
    .map((user: any) => {
      const depart = departmentsData.find(
        (item: any) => item._id === user.main_department
      );

      const userActivitiesCount =
        (articlesData?.filter(
          (art: any) =>
            art.created_by === user._id &&
            moment(art.created_at).utc().isSameOrAfter(oneWeekAgo)
        ).length || 0) +
        (projectsData?.filter(
          (pro: any) =>
            pro.created_by === user._id &&
            moment(pro.created_at).utc().isSameOrAfter(oneWeekAgo)
        ).length || 0) +
        (newsData?.filter(
          (news: any) =>
            news.created_by === user._id &&
            moment(news.created_at).utc().isSameOrAfter(oneWeekAgo)
        ).length || 0);

      const score =
        totalActivities > 0
          ? Math.round((userActivitiesCount * 100) / totalActivities)
          : 0;

      return {
        id: user._id,
        name: `${user.firstname} ${user.lastname}`,
        score,
        department: depart ? depart.name : "",
        avatarUrl: user.picture,
      };
    });

  return userData;
}
